import { ReduxStore } from 'store/types';

function editIsLoading(state: ReduxStore): boolean {
  return state.manufacturer.edit.config.isLoading;
}

export default editIsLoading;
